import { Navigate } from "react-router-dom";
import RequireRole from "./RequireRole.js";

// Fake Overview


//Dashboard
import Dashboard from "../Pages/Dashboard/Dashboard.js";

// Import Calender
import Calender from "../Pages/Calender";

//import icones
import MaterialIconsGallery from "../Pages/Utility/icons.js";

// Import Iximaker
import ProcedureManage from "../Pages/Iximaker/Procedure/procedureManage.js";
import StagesManage from "../Pages/Iximaker/Stage/stagesManage.js";

// headset details
import Headset from "../Pages/Iximaker/ParcXr.js";
import DetailsCompany from "../Pages/DetailsView/companyDetails.js";
// Import Authentication Inner Pages
import Login1 from "../Pages/AuthenticationPages/Login";
import Login2 from "../Pages/AuthenticationPages/HeadsetLogin.js";
import Register2 from "../Pages/AuthenticationPages/HeadsetRegister";
import Register1 from "../Pages/AuthenticationPages/Register";
import RecoverPassword from "../Pages/AuthenticationPages/RecoverPassword";
import UserProfile from "../Pages/AuthenticationPages/UserProfile";

// Import Utility Pages
import Maintenance from "../Pages/Utility/Maintenance-Page";
import ComingSoon from "../Pages/Utility/ComingSoon-Page";

import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";

// Import Formation Detail
import FormationDetail from "../Pages/Dashboard/FormationDetail";
import StageDetail from "../Pages/Dashboard/StageDetail";
import ListUser from "../Pages/Dashboard/ListUser.js";

import StepsManage from "../Pages/Iximaker/Step/stepsManage.js";
import HomeMonoPageWork from "../Pages/Iximaker/home_monopageWork.js";
import LanguageManageWork from "../Pages/Iximaker/Chapitre/languageManageWork.js";
import LanguageManageLearn from "../Pages/Iximaker/Chapitre/languageManageLearn.js";
import HomeMonoPageLearn from "../Pages/Iximaker/home_monopageLearn.js";
import { path } from "framer-motion/client";
import Landing from "../Pages/Iximaker/landing.js";

import ParcXr from "../Pages/Iximaker/ParcXr.js";
import AdminCreator from "../Pages/Iximaker/adminCreator.js";
import IXIWORK from "../Pages/Iximaker/ixiWork.js";
import IXIPLACE from "../Pages/Iximaker/ixiPlace.js";
import IXIVARIANT from "../Pages/Iximaker/ixiVariant.js";

import LogsWIP from "../Pages/Iximaker/logsWIP.js";
import GestionAdmin from "../Pages/Iximaker/GestionAdmin.js";
import GestionSuperAdmin from "../Pages/Iximaker/GestionSuperAdmin.js";
import Models3dPlus from "../Pages/Iximaker/serviceplus/3dmodels.js";
import PhotoscansPlus from "../Pages/Iximaker/serviceplus/photoscans.js";
import DevelopmentPlus from "../Pages/Iximaker/serviceplus/development.js";
import SupportPlus from "../Pages/Iximaker/serviceplus/support.js";
import RequestBuild from "../Pages/Iximaker/RequestBuild.js";

import UserDashboard from "../Pages/Dashboard/UserDashboard.js";
import { exact } from "prop-types";
import ChapterLogs from "../Pages/Dashboard/ChapterLogs.js";
import ListContenuRefAdmin from "../Pages/Iximaker/ListContenuRefAdmin.js";
import IXiMultiScreenDownload from "../Pages/Iximaker/IXiMultiScreenDownload.js";

import AsNavFor from "../Pages/Utility/TimeLine-Page.js";


const authProtectedRoutes = [
  { path: "/auth-register", component: <Register1 /> },
  // Dashboard
  { path: "/dashboard", component: <RequireRole allowedRoles={[1, 2]}><Dashboard /></RequireRole> },
  // Iximaker
  { path: "/procedureManage", component: <ProcedureManage /> },
  { path: "/procedureManage/:filename", component: <ProcedureManage /> },
  { path: "/homemono/:chapterName/:folderName", component: <HomeMonoPageWork /> },
  { path: "/homemono/:chapterName/:folderName/:filename", component: <ProcedureManage /> },
  { path: "/homemono", component: <Navigate to="/ixivariant" /> }, // Redirection si accès direct sans paramètres
  { path: "/procedures/:folderName/:filename/stagesManage", component: <StagesManage /> },
  { path: "/languageManageWork/:chapterName", component: <LanguageManageWork /> },
  { path: "/languageManageLearn/:chapterName", component: <LanguageManageLearn /> },
  { path: "/procedureEdit/:folderName/:filename", component: <ProcedureManage /> },
  { path: "/allStepsManage", component: <StepsManage /> },
  { path: "/homemonoLearn/:chapterName/:folderName", component: <HomeMonoPageLearn /> },
  { path: "/adminManage", component: <RequireRole allowedRoles={[1, 2]}> <AdminCreator /></RequireRole> },
  { path: "/logs", component: <RequireRole allowedRoles={[1, 2]}><LogsWIP /></RequireRole> },
  { path: "/ixiwork", component: <RequireRole allowedRoles={[1, 2, 3]}><IXIWORK /></RequireRole> },
  { path: "/ixiplace", component: <RequireRole allowedRoles={[1, 2, 4]}><IXIPLACE /></RequireRole> },
  { path: "/ixivariant", component: <RequireRole allowedRoles={[1, 2, 4]}><IXIVARIANT /></RequireRole> },

  // Calendar
  { path: "/calendar", component: <RequireRole allowedRoles={[1, 2]}> <Calender /></RequireRole> },

  // Profile Company
  { path: "/companyDetails", component: <DetailsCompany /> },

  // Headset
  { path: "/headset", component: <RequireRole allowedRoles={[1, 2, 4]}> <ParcXr /></RequireRole> },

  // iXiMultiScreen download
  { path: "/ixi-multiscreen", component: <RequireRole allowedRoles={[1, 2, 4]}><IXiMultiScreenDownload /></RequireRole> },
  { path: "/userprofile", component: <UserProfile /> },

  // Formation Details
  { path: "/formation/:id", component: <FormationDetail /> },

  // Stage Details
  { path: "/step/:id", component: <StageDetail /> },

  { path: "/admins", component: <RequireRole allowedRoles={[1, 2]}><GestionAdmin /></RequireRole> },


  // User List
  { path: "/users", component: <RequireRole allowedRoles={[1, 2]}><ListUser /></RequireRole> },

  {
    path: "/user-dashboard/:userId",
    component: (
      <RequireRole allowedRoles={[1, 2]}>
        <UserDashboard />
      </RequireRole>
    ),
  },

  { path: "/listsuperadmin", component: <RequireRole allowedRoles={[1]}><GestionSuperAdmin /></RequireRole> },

  // Chapter Manage Learn

  // landing page
  {
    path: "/landing",
    component: <Landing />
  },

  // Redirect to the landing page after login
  {
    path: "/",
    exact: true,
    component: <Navigate to="/landing" />,
  },
  { path: "/iconsMdi", component: <MaterialIconsGallery /> },

  { path: "/listContenuRefAdmin", component: <ListContenuRefAdmin /> },

  { path: "/timeline", component: <AsNavFor /> },


  //Service +
  { path: "/3Dmodels", component: <Models3dPlus /> },
  { path: "/photoscans", component: <PhotoscansPlus /> },
  { path: "/development", component: <DevelopmentPlus /> },
  { path: "/support", component: <SupportPlus /> },
  { path: "/builds", component: <RequestBuild /> },

  {
    path: "/user/:userId/chapter/:chapterName",
    component: (
      <RequireRole allowedRoles={[1, 2]}>
        <ChapterLogs />
      </RequireRole>
    ),
  },


];

const publicRoutes = [
  // Authentication Inner Pages
  { path: "/auth-login", component: <Login1 /> },
  { path: "/headset-login", component: <Login2 /> },
  { path: "/headset-register", component: <Register2 /> },

  //{ path: "/auth-recoverpw", component: <RecoverPassword /> },

  // Utility Pages
  { path: "/pages-404", component: <Error404 /> },
  { path: "/pages-500", component: <Error500 /> },
  { path: "/pages-maintenance", component: <Maintenance /> },
  { path: "/pages-comingsoon", component: <ComingSoon /> },

];

export { authProtectedRoutes, publicRoutes };

//Creators : Florian Cohen-Joly / Franck Douaud / Thomas Castanier/ Léo Yang @3DDGAMES -- Under license